// extracted by mini-css-extract-plugin
module.exports = {"companyAboutPage":"About_companyAboutPage_1inAE","companyAboutPageTitle":"About_companyAboutPageTitle_2_9dR"};